import type { AddressStored } from "@jti/fe-common";
import { isNonEmptyString } from "@jti/fe-common";

/*
  Clear region data when the original address country doesn't match checkout config country.
  Region IDs are country-specific, so keeping them would cause Magento validation errors
*/
export const getAddressRegionData = (countryCode: string, address: AddressStored) => {
  const isCountryMismatch = address.countryCode !== countryCode;

  if (isCountryMismatch) {
    return {
      region: undefined,
      regionCode: undefined,
    };
  }

  return {
    region: address.region,
    regionCode: address.regionCode,
  };
};

export const hasAddressHomeDeliveryValue = (address?: Partial<AddressStored> | null): boolean => {
  if (!address) {
    return false;
  }

  if (isNonEmptyString(address.id)) {
    return true;
  }

  return [address.streetName, address.streetNumber, address.postcode, address.city].every(isNonEmptyString);
};
